exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._7K0FCM9S4ktlJe_USBPkI{padding-bottom:0;padding-top:0}._1UnwbAW8Tg2dDoTB9uEcs{margin:0}._1j_tRb5kUeh2Jg2DPpvPsE{margin:0;padding-top:.5em}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"bigViewportWidth": "800px",
	"hugeViewportWidth": "980px",
	"GroupDetail_container": "_2o4czAjfqt4lyIPZGdP6Mj",
	"GroupDetail_content": "_7K0FCM9S4ktlJe_USBPkI",
	"GroupDetail_content_grid": "_1UnwbAW8Tg2dDoTB9uEcs",
	"GroupDetail_item": "_1j_tRb5kUeh2Jg2DPpvPsE"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/Dashboard/GroupDetail/style.postcss
// module id = 1237
// module chunks = 0